import { focusItems } from "@/mocks/home";

const toneMap: Record<
  string,
  { chip: string; icon: string; num: string }
> = {
  primary: { chip: "bg-primary-100 text-primary-800", icon: "text-primary-500", num: "text-primary-600" },
  accent: { chip: "bg-accent-100 text-accent-900", icon: "text-accent-600", num: "text-accent-700" },
  secondary: { chip: "bg-secondary-100 text-secondary-900", icon: "text-secondary-600", num: "text-secondary-700" },
};

function FocusSection() {
  return (
    <section id="focus" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-20">
        <div className="grid gap-6 lg:grid-cols-[1fr_360px]">
          <div>
            <p className="mb-2 font-label text-xs uppercase tracking-[0.24em] text-primary-600">
              Core Questions
            </p>
            <h2 className="font-heading text-3xl font-black leading-snug text-foreground-950 md:text-4xl">
              网友反复追问的
              <span className="text-primary-600">四大焦点</span>
            </h2>
            <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-foreground-600">
              所谓“四一爆料是谁”，落到具体问法上无非四件事：叫什么名字、长什么样子、什么来路、为什么干这事。每一条都按“现有说法 + 核实程度”拆开，大小卡片混排，信息量从上到下逐层加密。
            </p>
          </div>

          <div className="flex items-end justify-start">
            <p className="mb-1 inline-flex items-center gap-2 rounded-md bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900">
              <i className="ri-question-mark"></i>
              口径：只汇总公开讨论，不作实锤认定
            </p>
          </div>
        </div>

        {/* mixed grid */}
        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-6">
          {focusItems.map((item) => {
            const t = toneMap[item.tone];
            const wide = item.size === "lg";
            return (
              <article
                key={item.id}
                className={
                  "group flex flex-col rounded-lg ring-1 ring-background-200/70 " +
                  (wide ? "sm:col-span-2 lg:col-span-4 " : "lg:col-span-2 ") +
                  (item.tone === "primary" ? "bg-primary-50" : item.tone === "accent" ? "bg-accent-100/70" : "bg-secondary-100/70")
                }
              >
                <div className="p-5 md:p-7">
                  <div className="flex items-center justify-between gap-3">
                    <span className={"font-label text-sm italic " + t.num}>{item.index}</span>
                    <span className={"rounded-full px-2.5 py-1 text-xs font-medium " + t.chip}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="mt-4 font-heading text-xl font-black leading-snug text-foreground-950 md:text-2xl">
                    {item.title}
                  </h3>
                  <p className={"mt-3 leading-relaxed text-foreground-700 " + (wide ? "max-w-3xl" : "text-sm")}>
                    {item.brief}
                  </p>
                </div>
                <div className="mt-auto flex items-center gap-2 border-t border-background-200/60 px-5 py-3 md:px-7">
                  <i className={"ri-error-warning-line text-base " + t.icon}></i>
                  <span className="text-xs font-medium text-foreground-600">{item.note}</span>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default FocusSection;